import './vendor';
import Swiper from '../../node_modules/swiper/js/swiper.js';
import { fancybox } from '@fancyapps/fancybox';
import noUiSlider from 'nouislider';
import wNumb from 'wnumb';
import { inputmask } from 'inputmask/dist/jquery.inputmask.bundle';

const $document = $(document);
const $window = $(window);
const $html = $('html');

let app = {
	global: {
		init() {
			$('.js-goto').on('click', (e) => {
				let $target = $($(e.currentTarget).data('target')) || $($(e.currentTarget).attr('href'));

				if ($target.length) {
					e.preventDefault();
					$('html, body').animate({
						scrollTop: $target.offset().top - 100,
					}, 400);
				}
			});

			$document.on('click', '.js-toggle-class', (e) => {
				e.preventDefault();

				let options = $(e.currentTarget).data();

				switch (options.type) {
					case 'add':
						$html.addClass(options.class);
						break;
					case 'remove':
						$html.removeClass(options.class);
						break;
					case 'toggle':
						$html.toggleClass(options.class);
						break;
					default:
						$html.toggleClass(options.class);
						break;
				}
			});
		},
	},
	header: {
		init($header) {
			let $menu = $header.find('.header__menu');

			$header.find('.header__menu__burger').on('click', (e) => {
				e.preventDefault();
				$menu.toggleClass('is-show');
			});
			let isHeaderFixed = false,
				$headerNav = $('.js-header');
			$window.on('load scroll', ()=> {
				let $windowScrollTop = $window.scrollTop();
				if($windowScrollTop >= 200) {
					if(!isHeaderFixed) {
						$headerNav.addClass('header_fixed');
						isHeaderFixed = true;
					}
				} else {
					if(isHeaderFixed) {
						$headerNav.removeClass('header_fixed');
						isHeaderFixed = false;
					}

				}
			});

			$document.on('click', (e) => {
				let $target = $(e.target);

				if (!$target.closest('.header__menu').length) {
					$menu.removeClass('is-show');
				}
			});
		},
	},
	language: {
		init($language) {
			$language.find('.header__language__label').on('click', (e) => {
				e.preventDefault();
				$language.toggleClass('is-show');
			});

			$document.on('click', (e) => {
				let $target = $(e.target);

				if (!$target.closest('.header__language').length) {
					$('.header__language').removeClass('is-show');
				}
			});
		},
	},
	tuning: {
		init($tuning) {
			$document.on('click', '.tuning__list a', (e) => {
				let $this = $(e.currentTarget);
				let $list = $tuning.find('.tuning__list a');
				let $items = $tuning.find('.tuning__item');

				e.preventDefault();

				$items.removeClass('is-active');
				$list.removeClass('is-active');
				$this.addClass('is-active');
				$(`.tuning__item[data-item="${$this.data('item')}"]`).addClass('is-active');
			});

			$document.on('click', '.tuning__nav__prev', (e) => {
				let $active = $tuning.find('.tuning__list a.is-active');
				let $next = $active.closest('li').prevAll('li.tuning__list__item').eq(0);

				e.preventDefault();

				if (!$next.length) {
					$next = $tuning.find('.tuning__list li.tuning__list__item:last-of-type');
				}

				$next.find('a').trigger('click');
			});

			$document.on('click', '.tuning__nav__next', (e) => {
				let $active = $tuning.find('.tuning__list a.is-active');
				let $next = $active.closest('li').nextAll('li.tuning__list__item').eq(0);

				e.preventDefault();

				if (!$next.length) {
					$next = $tuning.find('.tuning__list li.tuning__list__item:eq(0)');
				}

				$next.find('a').trigger('click');
			});
		},
	},
	connect: {
		init($connect) {
			new Swiper($connect.find('.swiper-container'), {
				slidesPerView: 1,
				spaceBetween: 25,
				navigation: {
					prevEl: $connect.find('.connect__slider__prev')[0],
					nextEl: $connect.find('.connect__slider__next')[0],
				},
				pagination: {
					el: $connect.find('.connect__slider__pager')[0],
					clickable: true,

				},
				breakpoints: {
					768: {
						slidesPerView: 2,
					},
					992: {
						slidesPerView: 3,
					},
				},
			});
		},
	},
	massmedia: {
		init($connect) {
			new Swiper($connect.find(".swiper-container"), {
				slidesPerView: 1,
				spaceBetween: 0,
				navigation: {
					prevEl: $connect.find(".mass-media__slider__prev")[0],
					nextEl: $connect.find(".mass-media__slider__next")[0],
				},
				pagination: {
					el: $connect.find(".mass-media__slider__pager")[0],
					clickable: true,
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2,
					},
					992: {
						slidesPerView: 3,
						slidesPerGroup: 3,
					},
				},
			});
		},
	},
	reviews: {
		init($reviews) {
			const slider = new Swiper($reviews.find('.swiper-container'), {
				slidesPerView: 1,
				spaceBetween: 100,
				autoHeight: window.innerWidth < 768,
				calculateHeight: window.innerWidth < 768,
				pagination: {
					el: '.swiper-pagination__dots',
					clickable: true,
					dynamicMainBullets	: 3,
				},
				navigation: {
					prevEl: $reviews.find('.swiper-pagination__prev')[0],
					nextEl: $reviews.find('.swiper-pagination__next')[0],
				},
				on: {
					slideChange: function() {
						let $slider = this.$el;

						$slider.find('.js-reviews-text-parent').removeClass('reviews__slider__item__text_show');
						$slider.find('.js-showmore-btn').text('читать полностью');
					},
					init: function() {
						let $slider = this.$el;
						let $slides = $slider.find('.swiper-slide');

						$.each($slides, function() {
							let $slide = $(this);
							let $reviewsTextParent = $slide.find('.js-reviews-text-parent');
							let $reviewsText = $reviewsTextParent.find('.js-reviews-text');
							let reviewsTextHeight = $reviewsText.innerHeight();

							if (reviewsTextHeight > 300) {
								$reviewsTextParent.addClass('reviews__slider__item__text_limitation');
							}
						});
						$slider.on('click', '.js-showmore-btn', function() {
							let $showMoreBtn = $(this);
							let $reviewsTextParent = $(this).closest('.reviews__slider__item').find('.js-reviews-text-parent');

							if (!$reviewsTextParent.hasClass('reviews__slider__item__text_show')) {
								$showMoreBtn.text('свернуть');
								$reviewsTextParent.addClass('reviews__slider__item__text_show');
							} else {
								$showMoreBtn.text('читать полностью');
								$reviewsTextParent.removeClass('reviews__slider__item__text_show');
							}

							slider.updateAutoHeight();
						});
					},
				},
			});
		},
	},
	tariffs: {
		init($tariffs) {
			let $range = $tariffs.find('.tariffs__choose__item__range');

			let $location = $tariffs.find('.tariffs__choose__item__location');

			$range.each((index, item) => {
				let $this = $(item);
				let $slider = $this.find('.tariffs__choose__item__range__slider');
				if (!$slider.length) return;
				let $count = $this.find('.tariffs__choose__item__range__count span');
				let options = $slider.data();
				let $rangeStart = $(options.mininput);
				let $rangeEnd = $(options.maxinput);

				noUiSlider.create($slider[0], {
					start: options.start,
					step: options.step,
					connect: [true, false],
					range: {
						'min': options.min,
						'max': options.max,
					},
					format: wNumb({
						decimals: 0,
					}),
				});


		        let updateFunc = function () {
		          console.warn('updateFunc not init');
		        }; //Для слайдеров "сколько звонков" и "средняя длительность" на форме "Коллтрекинг"
		        if ($this.attr('id') === 'calls_count_slider' || $this.attr('id') === 'avg_count_slider') {
		          updateFunc = function (value) {
		            let utilFunc = window.sliders_util.updateCtSpansByCallsCount;
		            if ($this.attr('id') === 'calls_count_slider') {
		              let nAvgDuration = document.getElementById('range_avg_duration').innerText;
		              let nCallsCount = $slider[0].noUiSlider.get();
		            }
		            if ($this.attr('id') === 'avg_count_slider') {
		              let nAvgDuration = document.getElementById('range_calls_count').innerText;
		              let nCallsCount = $slider[0].noUiSlider.get();
		            }
		            utilFunc(value, nAvgDuration, nCallsCount)
		          };
		        }

		        //Для слайдера на форме "Обратный звонок"
		        if ($this[0].classList[1] === 'callback__slider') {
		            updateFunc = window.sliders_util.updateCallbackSpans;
		        //Для слайдера с кол-вом номеров
		        } else if ($this.attr('id') === 'tel_count_slider') {
		            updateFunc = window.sliders_util.updateCtSpansByNumbers;
		        }


				$slider[0].noUiSlider.on('update', (values, handle) => {
					let value = values[handle];

					updateFunc(value);
					$count.text(value);
				});
			});

			$location.find('.tariffs__choose__item__location__label button').on('click', (e) => {
				e.preventDefault();
				$location.toggleClass('is-show');
			});

			$location.find('.tariffs__choose__item__location__drop li').on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				$location.find('.tariffs__choose__item__location__label button').text($this.html());
				$location.find('.tariffs__choose__item__location__field').val($this.data('id'));
				$location.removeClass('is-show');
			});

			$document.on('click', (e) => {
				let $target = $(e.target);

				if (!$target.closest('.tariffs__choose__item__location').length) {
					$('.tariffs__choose__item__location').removeClass('is-show');
				}
			});
		},
	},
	'format-slider': {
		init($slider) {
			let $prev = $slider.find('.format__slider__prev');

			let $next = $slider.find('.format__slider__next');

			let $slides = $slider.find('.swiper-slide');

			let slider = {
				init() {
					slider.handlers();
					slider.prioritize();
				},
				handlers() {
					$prev.on('click', (e) => {
						e.preventDefault();
						slider.prev();
					});

					$next.on('click', (e) => {
						e.preventDefault();
						slider.next();
					});
				},
				prioritize() {
					let $active = $slider.find('.swiper-slide.is-active');
					let $activeNext = $active.next('.swiper-slide').length ? $active.next('.swiper-slide') : $slider.find('.swiper-slide:first-child');
					let $activeNextNext = $activeNext.next('.swiper-slide').length ? $activeNext.next('.swiper-slide') : $slider.find('.swiper-slide:first-child');
					let $activePrev = $active.prev('.swiper-slide').length ? $active.prev('.swiper-slide') : $slider.find('.swiper-slide:last-child');
					let $activePrevPrev = $activePrev.prev('.swiper-slide').length ? $activePrev.prev('.swiper-slide') : $slider.find('.swiper-slide:last-child');

					$slides.removeAttr('data-slide');
					$active.attr('data-slide', 0);
					$activePrev.attr('data-slide', -1);
					$activeNext.attr('data-slide', 1);
					$activePrevPrev.attr('data-slide', -2);
					$activeNextNext.attr('data-slide', 2);
				},
				next() {
					let $active = $slider.find('.swiper-slide.is-active');

					let $next = $active.next('.swiper-slide').length ? $active.next('.swiper-slide') : $slider.find('.swiper-slide:first-child');

					$active.removeClass('is-active');
					$next.addClass('is-active');
					slider.prioritize();
				},
				prev() {
					let $active = $slider.find('.swiper-slide.is-active');

					let $next = $active.prev('.swiper-slide').length ? $active.prev('.swiper-slide') : $slider.find('.swiper-slide:last-child');

					$active.removeClass('is-active');
					$next.addClass('is-active');
					slider.prioritize();
				},
			};

			slider.init();
		},
	},
	'format-form': {
		init($form) {
			$form.find('.format__checkbox input').on('change', (e) => {
				let $this = $(e.currentTarget);

				let type = $this.data('type');

				let $logo = $form.find('.format__form__logo');

				let $title = $form.find('.format__form__title');

				let $timer = $form.find('.format__form__timer');

				switch (type) {
					case 'logo':
						if ($this.is(':checked')) {
							$logo.addClass('is-active');
						} else {
							$logo.removeClass('is-active');
						}
						break;
					case 'title':
						if ($this.is(':checked')) {
							$title.addClass('is-active');
						} else {
							$title.removeClass('is-active');
						}
						break;
					case 'color':
						if ($this.is(':checked')) {
							$title.css("color", "#f00");
						} else {
							$title.css("color", "#fff");
						}
						break;
					case 'timer':
						if ($this.is(':checked')) {
							$timer.addClass('is-active');
						} else {
							$timer.removeClass('is-active');
						}
						break;
				}
			});

			$form.find('.format__form__add button').on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				$form.find(`.format__checkbox input[data-type="${$this.data('type')}"]`).prop('checked', true).trigger('change');
			});
		},
	},
	mask: {
		init($input) {
			let mask = $input.data('mask').toString();

			let max = $input.data('max');

			$input.inputmask(mask, {
				showMaskOnHover: false,
			});

			if (max) {
				$input.on('keyup', () => {
					if (parseInt($input.val(), 10) > max) {
						$input.val('00');
					}
				});
			}
		},
	},
	night: {
		init($night) {
			let $input = $night.find('.night__content__title__switch input');

			$input.on('change', (e) => {
				if ($input.is(':checked')) {
					$night.attr('data-type', 'night');
				} else {
					$night.attr('data-type', 'light');
				}
			})
		},
	},
	repost: {
		init() {
			let $repostTab = $('.js-repost-tab'),
				$repostAnaliticItem = $('.js-analitic-item');

			$.each($repostTab, function(i) {
				$(this).on('click', function() {
					$repostTab.removeClass('repost__btn_active');
					$repostTab.eq(i).addClass('repost__btn_active');
					$repostAnaliticItem.removeClass('repost__analitic-item_analitic_active');
					$repostAnaliticItem.eq(i).addClass('repost__analitic-item_analitic_active');
				});
			});
		}
	},
	integration: {
		init($integration) {
			const reviewsSwiper = new Swiper($integration.find('.swiper-container'), {
				slidesPerView: 'auto',
				loop: true,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
					dynamicMainBullets	: 3,
				},
				navigation: {
					prevEl: $integration.find('.integration__slider__prev')[0],
					nextEl: $integration.find('.integration__slider__next')[0],
				},
			});
		}
	}
};

app.global.init();


$('[data-app]').each((index, item) => {
	let $this = $(item);

	let appName = $this.data('app');

	if (app[appName]) {
		app[appName].init($this);
	}
});
